
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.5.875C5.184.875.875 5.185.875 10.5c0 5.316 4.31 9.625 9.625 9.625 5.316 0 9.625-4.31 9.625-9.625 0-5.316-4.31-9.625-9.625-9.625zm4.172 7.998a.875.875 0 10-1.344-1.12l-3.762 4.514-1.947-1.948a.875.875 0 00-1.238 1.237l2.625 2.625a.876.876 0 001.291-.058l4.375-5.25z","fill":"#A6CD39"}})])
          )
        }
      }
    